/* eslint object-property-newline: 0 */

const BRAIN_TICKS_PER_SECOND = 10;
const CANVAS_HEIGHT = 300;
const CANVAS_WIDTH = 1280;
const CAR_HEIGHT = 100;
const CAR_WIDTH = 200;
const COLORS = {
  asphalt: '#282B2A',
  generic: ['#F7DBD7', '#CBBFB0', '#FAEACB', '#BDC2C2', '#739194', '#88BCE8', '#9CC0E7', '#FCFCFC'],
  goalArea: '#FFD700',
  player: '#DB2929',
  sensor: '#EEEEEE',
};
const FRAMES_PER_SECOND = 24;
const LS_CODE_KEY = 'parkit_usercode';
const MAX_ANGLE_THRESHOLD = 35;
const MAX_ANGLE_CHANGE_PER_TICK = 5;
const MAX_SPEED_CHANGE_PER_TICK = 0.6;
const PIXELS_PER_METER = 10;
const SENSOR_METERS_RANGE = 7;
const SENSORS_QT = 20;
const SENSOR_RANGE = SENSOR_METERS_RANGE * PIXELS_PER_METER;
const SENSOR_BREAKPOINTS_QT = SENSOR_RANGE;
const SPEED_RATIO = 60;
const ANGLE_TO_SPEED_RATIO = 60;

export default {
  ANGLE_TO_SPEED_RATIO, BRAIN_TICKS_PER_SECOND, CANVAS_HEIGHT, CANVAS_WIDTH, CAR_HEIGHT,
  CAR_WIDTH, COLORS, FRAMES_PER_SECOND, LS_CODE_KEY, MAX_ANGLE_THRESHOLD,
  MAX_ANGLE_CHANGE_PER_TICK, MAX_SPEED_CHANGE_PER_TICK, PIXELS_PER_METER, SENSOR_BREAKPOINTS_QT,
  SENSOR_METERS_RANGE, SENSORS_QT, SENSOR_RANGE, SPEED_RATIO,
};
